import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Fleet } from '../../models/fleet.model';
import { PublicApiService } from '../../services/public-api.service';

interface FleetAlertsSummary {
  withNoAlerts: number;
  withWarnings: number;
  withErrors: number;
  withQCErrors: number;
  withQCAlerts: number;
}

@Component({
  selector: 'app-fleet-health',
  templateUrl: './fleet-health.component.html',
  styleUrls: ['./fleet-health.component.scss'],
})
export class FleetHealthComponent implements OnInit {
  @Input() selectedFleet: Fleet | null = null;
  @Output() indicatorClicked = new EventEmitter<string>();

  loading: boolean = true;
  error: string | null = null;
  alertsSummary: FleetAlertsSummary | null = null;

  constructor(private apiService: PublicApiService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedFleet'].previousValue !== changes['selectedFleet'].currentValue) {
      this.loadFleetAlertsSummary();
    }
  }

  loadFleetAlertsSummary(): void {
    if (this.selectedFleet) {
      this.loading = true;
      this.apiService.getFleetAlertsSummary(this.selectedFleet.uuid).subscribe({
        next: (response: any) => {
          this.alertsSummary = response;
          this.loading = false;
        },
        error: (err: Error) => {
          this.error = 'Failed to load alerts summary.';
          this.loading = false;
          console.error('Error loading fleets:', err);
        },
      });
    }
  }

  setIndicatorCLicked(indicator: string): void {
    this.indicatorClicked.emit(indicator);
  }
}
